export class LoadDreamboxImages {
  static readonly type = '[Dreambox] Load dreambox images';
  constructor(public preserveResults: boolean = false) {}
}
